import { render, staticRenderFns } from "./BlogArchive.vue?vue&type=template&id=6155aaa7&"
import script from "./BlogArchive.vue?vue&type=script&lang=js&"
export * from "./BlogArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports